import { Product } from 'src/services/products';

export function createEmptyPackaging(
  packagingId: () => number = () => Math.floor(Math.random() * 10000000), // will be overwritten by backend
): NonNullable<Product['product_packagings']>[number] {
  return {
    id: packagingId(),
    barcode: '',
    name: '',
    quantity: 0,
  };
}
